import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getFormatDateWithDaysAgo } from 'utilities/date';
import { CollapsibleContent, CollapsibleDisclosure, useCollapsibleState } from 'components/Collapsible';

import { getDisplayUserName } from '../utility';

import { answerPropTypes } from './propTypes';
import ProductAnswerReplyToReplyCard from './ProductAnswerReplyToReplyCard';
import ProductSubmitReplyForm from './ProductSubmitReplyForm';
import ProductQuestionsAndAnswersThankYou from './ProductQuestionsAndAnswersThankYou';

import './ProductAnswerReplyCard.scss';

const ProductAnswerReplyCard = ({ answerId, reply }) => {

	const {
		id: parentReplyId, text, user, dateCreated, replies, isStaff
	} = reply;
	const [ showThankYouMessage, setShowThankYouMessage ] = useState(false);
	const collapsibleReplyToReplyForm = useCollapsibleState(false);

	const handleReplySubmit = () => {

		collapsibleReplyToReplyForm.setOpen(false);
		setShowThankYouMessage(true);

	};

	const handleReplyCancel = () => {

		collapsibleReplyToReplyForm.setOpen(false);

	};

	return (
		<>
			<div className="ProductAnswerReplyCard">
				<div className="ProductAnswerReplyCard__body">
					<div className="ProductAnswerReplyCard__text">
						<span dangerouslySetInnerHTML={{ __html: text }} />
					</div>
					<div className="ProductAnswerReplyCard__userContainer">
						<div className="ProductAnswerReplyCard__username">
							{getDisplayUserName(user)}
							{user?.badge && (
								<span className="ProductAnswerReplyCard__badge">
									{user.badge.text}
								</span>
							)}
							{!user.badge && isStaff && <span className="ProductAnswerReplyCard__badge">Staff</span>}
						</div>
						<div className="ProductAnswerCard__btnContainer">
							<CollapsibleDisclosure {...collapsibleReplyToReplyForm}>Reply</CollapsibleDisclosure>
						</div>
						<div className="ProductAnswerReplyCard__dateCreated">
							{getFormatDateWithDaysAgo(dateCreated)}
						</div>
					</div>
				</div>
			</div>
			<CollapsibleContent {...collapsibleReplyToReplyForm}>
				<ProductSubmitReplyForm
					answerId={answerId}
					parentReplyId={parentReplyId}
					replyTo={getDisplayUserName(user)}
					onSubmit={handleReplySubmit}
					onCancel={handleReplyCancel}
				/>
			</CollapsibleContent>

			{showThankYouMessage && (
				<ProductQuestionsAndAnswersThankYou message="Your reply has been submitted. If you provided your email, you may receive notifications for 14 days. Otherwise, return to this page to see any replies." />
			)}
			{replies.map((rep) => (
				<ProductAnswerReplyToReplyCard key={rep.id} reply={rep} />
			))}
		</>
	);

};

ProductAnswerReplyCard.propTypes = {
	answerId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
	reply: answerPropTypes
};

export default ProductAnswerReplyCard;
